import script from "./InputTags.vue?vue&type=script&setup=true&lang=js"
export * from "./InputTags.vue?vue&type=script&setup=true&lang=js"

import "./InputTags.vue?vue&type=style&index=0&id=ab827bb4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab827bb4"]])

export default __exports__